import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import VendorLogo from '../components/VendorLogo';
import { wait } from '../utils/wait';
import WelcomeSection from '../modules/sections/WelcomeSection';
import TopicsSection from '../modules/sections/TopicsSection';
import { useConfig } from '../hooks';

interface Props {
  setTopic: (topic: string) => void;
  topic: string | null;
}

const Welcome = ({ topic, setTopic }: Props) => {
  const [highlightedTopic, setHighlightedTopic] = useState<string | null>(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { data: config } = useConfig();

  useEffect(() => {
    if (config && config.infoCardTopics && config.infoCardTopics.length === 0) {
      navigate({ pathname: '/ai-chatbot', search: location.search }, { replace: true });
    }
  }, [config, location.search, navigate]);

  const handleTopicSelect = async (option: string) => {
    setHighlightedTopic(option);
    setTopic(option);
    await wait(500);
    setHighlightedTopic(null);
  };

  return (
    <div className="mx-auto space-y-4 rounded-lg py-4 max-w-xl">
      <VendorLogo />

      <WelcomeSection />

      <TopicsSection
        handleTopicSelect={handleTopicSelect}
        topic={topic}
        highlightedTopic={highlightedTopic}
      ></TopicsSection>
    </div>
  );
};

export default Welcome;
